import React from "react";
const KS2SeactionAHeader = () => {
  return (
    <div className="row  section-box">
      <div className="kr-title">
        <div className="form-check disabled">
          <input className="form-check-input " type="radio" disabled style={{ marginRight: "15px" }} />
          <label className="form-check-label pl-3 pr-4">Section A</label>
        </div>
      </div>
      <div className="personal-details">
        <span className="title pr-1">General</span>
        <div className="form-check disabled pl-1">
          <label className="form-check-label blockletterrs-use pr-2">Please put a dash to indicate your situation eg &nbsp;&nbsp;</label>
          <input className="dash-textbox" type="text" value="-" disabled />
        </div>
      </div>
    </div>
  );
};
export default KS2SeactionAHeader;
